import React, { useState } from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const fieldOptions = [
  {
    label: 'Market Share of Units Sold',
    id: 'unitsSold',
    fieldName: 'unitsSold'
  },
  {
    label: '1P Market Share of Units Sold',
    id: 'firstPartyUnitsSold/unitsSold',
    fieldName: 'firstPartyUnitsSold'
  },
  {
    label: '1P Market Share of 1P Units Sold',
    id: 'firstPartyUnitsSold/firstPartyUnitsSold',
    fieldName: 'firstPartyUnitsSold'
  },
  {
    label: '3P Market Share of Units Sold',
    id: 'thirdPartyUnitsSold',
    fieldName: 'thirdPartyUnitsSold'
  },
  {
    label: '3P Market Share of 3P Units Sold',
    id: 'thirdPartyUnitsSold/thirdPartyUnitsSold',
    fieldName: 'thirdPartyUnitsSold'
  }
];

const AtlasV2SalesMarketShareOfUnitsSoldChart = () => {
  const [selectedField, setSelectedField] = useState(fieldOptions[0]);
  return (
    <AtlasV2DorisSplineChart
      queryKey="UnitsSoldMarketShareSplineChart"
      title={selectedField.label}
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType={selectedField.fieldName}
      showMarketShare={true}
      marketShareRequestBuilder={(params) => {
        switch (selectedField.id) {
          case 'unitsSold':
          case 'thirdPartyUnitsSold/thirdPartyUnitsSold':
            return {
              ...params,
              brandIds: []
            };
          case 'firstPartyUnitsSold/unitsSold':
          case 'thirdPartyUnitsSold':
            return {
              ...params,
              brandIds: [],
              metricType: 'unitsSold'
            };
          case 'firstPartyUnitsSold/firstPartyUnitsSold':
            return {
              ...params,
              brandIds: [],
              metricType: 'firstPartyUnitsSold'
            };
          default:
            break;
        }
        return {
          ...params,
          brandIds: []
        };
      }}
      beaconChartWithLegendOverride={(props, metric) => {
        return {
          ...props,
          singleDropdownProps: {
            onChange: (s) => setSelectedField(fieldOptions.find((option) => option.id === s.id)),
            defaultLabel: selectedField.label,
            selectedId: selectedField.id,
            buttonVariant: 'title',
            options: fieldOptions,
            shouldShowFullItemText: true
          }
        };
      }}
    />
  );
};

export default AtlasV2SalesMarketShareOfUnitsSoldChart;
